import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { commonInputStyles, FormInputProps } from 'pages/checkout/components/common/input-styled-components';

type SelectWrapperProps = FormInputProps & {
  $isInvalid?: boolean;
};

export const SelectWrapper = styled.div<SelectWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 4px;

  /* Provider and Plan select are exported as an array,
  so we can't use regular styled-components to target them */
  && {
    div {
      width: 100%;

      & > .autocomplete-search-input {
        .ant-input {
          ${TYPOGRAPHY.CIRCULAR.book}
        }

        box-shadow: none;
        ${commonInputStyles}

        &:hover {
          box-shadow: none;
          border-color: ${BRAND_COLORS.stroke};
        }

        ${({ $isInvalid }) => $isInvalid && css`
          /* Other styles are overriding the border on hover, so we need !important */
          border-color: ${BRAND_COLORS.darkRed} !important;
        `}

        /* Apply focus styles to parent if input is focused */
        &:has(.ant-input:focus-visible) {
          border-color: ${BRAND_COLORS.lightGreen};
        }
      }
    }
  }
`;
